<script>
    export let src;
    export let alt;
    export let route;
</script>
<a href="./#/{route}"><img src="{src}" alt="{alt}" /></a>

<style>
    a{
        width: 75%;
    }
    img{
        width: 100%;
    }
</style>